import { CcpaData as CcpaDataWidget } from './components/ccpa-data';
import { CcpaMain as CcpaMainWidget } from './components/ccpa-main';
import { CcpaPartners as CcpaPartnersWidget } from './components/ccpa-partners';
import { AboutOurAds as AboutOurAdsWidget } from './components/about-our-ads';
import { Gdpr as GdprWidget } from './components/gdpr';
import { PrivacyPolicy as PrivacyPolicyWidget } from './components/privacy-policy';
import definition from './intl.json';
import intl from 'preact-i18n';

function intlWrap(component) { return intl(component, { scope: 'privacy-widgets', definition }); }

export const AboutOurAds = intlWrap(AboutOurAdsWidget);
export const CcpaData = intlWrap(CcpaDataWidget);
export const CcpaMain = intlWrap(CcpaMainWidget);
export const CcpaPartners = intlWrap(CcpaPartnersWidget);
export const Gdpr = intlWrap(GdprWidget);
export const PrivacyPolicy = intlWrap(PrivacyPolicyWidget);
